import { ref } from 'vue'

export type PlanLimitType = 'projects' | 'storage' | 'users'

export interface PlanLimitPayload {
  limit: PlanLimitType
  used: number
  max: number
}

const planLimitOpen = ref(false)
const planLimitPayload = ref<PlanLimitPayload | null>(null)

function showPlanLimit(payload: PlanLimitPayload): void {
  planLimitPayload.value = payload
  planLimitOpen.value = true
}

function closePlanLimit(): void {
  planLimitOpen.value = false
  planLimitPayload.value = null
}

/**
 * Singleton for use outside Vue components (e.g. api.ts).
 */
export const planLimitState = {
  get open() {
    return planLimitOpen.value
  },
  get payload() {
    return planLimitPayload.value
  },
  show: showPlanLimit,
  close: closePlanLimit,
}

/**
 * Composable for plan-limit modal in Vue components.
 */
export function usePlanLimit() {
  return {
    planLimitOpen,
    planLimitPayload,
    show: showPlanLimit,
    close: closePlanLimit,
  }
}
